module.exports = "/assets/e8a48b9d62f8508962c4c241ca91b0bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FV.png
// module id = 1383
// module chunks = 0